import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/home.module.css';

const DeveloperSection = ({
  title,
  description,
  bulletPoint,
  buttonText,
  buttonLink,
  image,
  imageAlt
}) => {
  return (
    <div className="homepage">
      <section className={styles.featureSection}>
        <div className={styles.newContent}>
          <div className={styles.newText}>
            <h3 style={{ fontSize: "1.5em", marginTop: "0" }} className={styles.header}>
              {title}
            </h3>
            <p style={{ fontSize: "1.1em" }} className={styles.paragraph}>
              {description}
            </p>
            <p>
              <span style={{ fontSize: "1.1em" }} className={styles.icon}>
                ✦
              </span>{" "}
              {bulletPoint}
            </p>
            <Link to={buttonLink}>
              <button className={`${styles.primaryButton} ${styles.webSignUpButton}`}>
                {buttonText}
              </button>
            </Link>
          </div>
          <div style={{
            position: "relative",
            display: "inline-block",
            gap: "50px",
          }}>
            <img
              className={styles.img}
              style={{
                maxWidth: "500px",
                height: "300px",
                display: "block",
                borderRadius: "8px",
              }}
              src={image}
              alt={imageAlt}
            />
          </div>
        </div>
        <button className={`${styles.primaryButton} ${styles.mobileSignUp}`}>
          {buttonText}
        </button>
      </section>
    </div>
  );
};

export default DeveloperSection;